import "../../../../DrugAssignmentBatchRelease/DrugAssignment.css";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CreateHandleUnsaveNavigation } from "../../../../../utilities/handleUnsaveNavigation";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useNavigationGuard from "../../../../../hooks/useNavigationGuard";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../../../utilities/helper";
import Loader from "../../../../../components/Loader";
import { Box, Divider, Grid2, TextField } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import SearchableSelect from "../../../../../components/SearchableSelect";
import {
  fetchBulkKitStatusOnLoadService,
  getBulkKitStatusDrugNumberService,
  saveBulkDataForKtStatusService,
} from "../../../../../services/siteManagamentService";
import { HandleUnsaveNavigationWithFun } from "../../../../../utilities/handleUnsaveNavigationWithFun";
import BulkConfirmationKitStatus from "./BulkConfirmPage/BulkConfirmPage";

const BulkKitStatus = () => {
  const [load, setLoad] = useState(false);
  const [loadData, setLoadData] = useState({
    currentStatusData: [],
    updateStatusData: [],
  });
  const [numOfDrugs, setNumOfDrugs] = useState("");
  const [showConfirmPage, setShowConfirmPage] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const navigate = useNavigate();

  const access_token = localStorage.getItem("access_token");
  const roleId = localStorage.getItem("roleId");
  const studyId = localStorage.getItem("studyId");
  const siteId = useLocation()?.state?.siteId;
  const siteName = useLocation()?.state?.siteName;

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const handleUnSaveNavigationFun = HandleUnsaveNavigationWithFun();

  const { currentStatusData, updateStatusData } = loadData;

  const createKitSchema = yup.object().shape({
    drugKitStatus: yup.string().required("Drug Kit status is required"),
    minKitNumber: yup.string().required("Min Kit Number is required"),
    maxKitNumber: yup.string().required("Max Kit Number is required"),
    minSequenceNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Min Sequence Number is not valid.")
      .required("Min Sequence Number is required"),
    maxSequenceNumber: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Max Sequence Number is not valid.")
      .required("Max Sequence Number  is required"),
    updateDrugStatus: yup.string().required("Drug Status is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(createKitSchema),
    defaultValues: {
      drugKitStatus: "",
      maxKitNumber: "",
      maxSequenceNumber: "",
      minKitNumber: "",
      minSequenceNumber: "",
      updateDrugStatus: "",
    },
  });

  useNavigationGuard(isDirty);

  useEffect(() => {
    if (siteId && roleId) {
      getOnLoadData(siteId, roleId);
    }
  }, [siteId, roleId]);

  useEffect(() => {
    if (
      currentStatusData &&
      currentStatusData?.length > 0 &&
      !showConfirmPage
    ) {
      getNumOfDrugData(currentStatusData[0]?.id);
    }
  }, [currentStatusData, showConfirmPage]);

  const values = watch();

  useEffect(() => {
    if (
      currentStatusData &&
      currentStatusData?.length > 0 &&
      !showConfirmPage
    ) {
      setTimeout(() => {
        getNumOfDrugData(
          values?.drugKitStatus,
          values?.minSequenceNumber,
          values?.maxSequenceNumber,
          values?.minKitNumber,
          values?.maxKitNumber
        );
      }, 200);
    }
  }, [values, currentStatusData, showConfirmPage]);

  const getOnLoadData = async (siteId, userId) => {
    try {
      setLoad(true);
      const res = await fetchBulkKitStatusOnLoadService(
        access_token,
        siteId,
        userId
      );
      if (res?.status == 200) {
        setLoad(false);
        const data = res?.data?.result;
        setLoadData({
          currentStatusData: data?.searchDrugStatus,
          updateStatusData: data?.assignableStatuses?.filter(
            (item) => item?.name !== ""
          ),
        });
        reset({
          drugKitStatus: data.searchDrugStatus[0]?.id,
        });
      }
    } catch (err) {
      console.log(err.message);
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const getNumOfDrugData = async (
    drugId,
    minSeq = 0,
    maxSeQ = 0,
    minKitNum = "",
    maxKitNum = ""
  ) => {
    try {
      const data = {
        drugStatusId: drugId,
        minSequenceNumber: Number(minSeq),
        maxSequenceNumber: Number(maxSeQ),
        minKitNumber: minKitNum,
        maxKitNumber: maxKitNum,
        depotId: "00000000-0000-0000-0000-000000000000",
        siteId: siteId,
      };
      const res = await getBulkKitStatusDrugNumberService(
        access_token,
        studyId,
        roleId,
        data
      );
      setNumOfDrugs(res?.data?.result);
    } catch (err) {
      console.log(err?.message);
    }
  };

  const updateBulkKitStatus = async (data) => {
    const new_data = {
      drugStatusId: data?.drugKitStatus,
      minSequenceNumber: data?.minSequenceNumber,
      maxSequenceNumber: data?.maxSequenceNumber,
      minKitNumber: data?.minKitNumber,
      maxKitNumber: data?.maxKitNumber,
      depotId: "00000000-0000-0000-0000-000000000000",
      siteId: siteId,
    };

    if (numOfDrugs === 0) {
      notifyWarning("Please Select range which has atlease one Drug Kit!");
      return;
    } else {
      try {
        setLoad(true);
        const res = await saveBulkDataForKtStatusService(
          access_token,
          new_data,
          siteId,
          studyId,
          roleId,
          data?.updateDrugStatus
        );

        if (res?.data?.status == 401) {
          setLoad(false);
          notifyError(res?.data?.message);
          // reset();
        } else {
          const data = res?.data?.result;
          setLoad(false);
          notifySuccess("Bulk Study Kit Status Saved Successfully");
          reset();
          setShowConfirmPage(true);
          setConfirmationData(data?.kitsReturnData);
        }
      } catch (err) {
        setLoad(false);
        setShowConfirmPage(false);
        console.log(err.message);
        notifyError(err?.message);
        if (err?.status == 401) {
          navigate("/unAuthorize");
        }
      }
    }
  };

  const minSequenceRegister = register("minSequenceNumber");
  const maxSequenceRegister = register("maxSequenceNumber");
  // const minKitNumberRegister = register("minKitNumber");
  // const maxKitNumberRegister = register("maxKitNumber");

  return (
    <>
      {showConfirmPage ? (
        <BulkConfirmationKitStatus
          setShowConfirm={setShowConfirmPage}
          siteId={siteId}
          siteName={siteName}
          data={confirmationData}
        />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p
                className="bread-crumbs-link-container"
                style={{ fontWeight: "600" }}
              >
                <Link className="bread-crumbs-link" to="/">
                  Home
                </Link>{" "}
                |{" "}
                <Link className="bread-crumbs-link" to="/site-management">
                  Site Management
                </Link>{" "}
                |
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    navigate("/addUpdate-site-management", {
                      state: { id: siteId },
                    })
                  }
                >
                  {siteName || "Site Details"}
                </button>
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    navigate("/bulk-kit-status", {
                      state: { siteId: siteId, siteName: siteName },
                    })
                  }
                >
                  Bulk Drug Kit Status Management
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>
              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={12}>
                  <p className="page-heading">
                    Bulk Drug Kit Status Management
                  </p>
                  <Divider />
                  <p className="page-sub-header">
                    <InfoOutlined className="info-icon" />
                    If you want to make an update to individual kits/units,
                    please use the{" "}
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnSaveNavigationFun(
                          e,
                          isDirty,
                          () => {
                            navigate("/individual-kit-status", {
                              state: {
                                id: siteId,
                                name: siteName,
                              },
                            });
                          },
                          () => {}
                        )
                      }
                      style={{ fontSize: "14px" }}
                    >
                      Individual update function
                    </button>
                  </p>
                </Grid2>
              </Grid2>
              <Box
                component="form"
                autoComplete="off"
                sx={{ height: "auto", width: "100%" }}
                onSubmit={handleSubmit(updateBulkKitStatus)}
              >
                <Grid2
                  container
                  alignItems="center"
                  justifyContent={"space-between"}
                  sx={{ width: "100%", margin: "0 auto", marginTop: "20px" }}
                  gap={1}
                >
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Current Drug Status
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={currentStatusData}
                        name="drugKitStatus"
                        noDefault={true}
                        optionKey="id"
                        optionLabel="description"
                      />
                    </div>
                    {errors.drugKitStatus && (
                      <div className="error-container">
                        {errors.drugKitStatus.message}
                      </div>
                    )}
                    {/* {numOfDrugs === "" && (
                      <div
                        style={{
                          marginTop: "4px",
                          fontSize: "small",
                          color: "#1976d2",
                        }}
                      >
                        {numOfDrugs} Drug Items Found
                      </div>
                    )} */}
                  </Grid2>
                  <div>
                    {numOfDrugs !== "" && (
                      <div className="drug-count-container-new">
                        {numOfDrugs} Drug {numOfDrugs === 1 ? "item" : "items"}{" "}
                        Found
                      </div>
                    )}
                  </div>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Update Drug Status
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={updateStatusData}
                        name="updateDrugStatus"
                        optionKey="id"
                        optionLabel="name"
                      />
                    </div>
                    {errors.updateDrugStatus && (
                      <div className="error-container">
                        {errors.updateDrugStatus.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Min Kit Number
                        <span>*</span>
                      </p>
                      <TextField
                        fullWidth
                        size="small"
                        type={"text"}
                        {...register("minKitNumber")}
                      />
                    </div>
                    {errors.minKitNumber && (
                      <div className="error-container">
                        {errors.minKitNumber.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}></Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Max Kit Number
                        <span>*</span>
                      </p>
                      <TextField
                        fullWidth
                        size="small"
                        type={"text"}
                        {...register("maxKitNumber")}
                      />
                    </div>
                    {errors.maxKitNumber && (
                      <div className="error-container">
                        {errors.maxKitNumber.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}></Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Min Sequence Number
                        <span>*</span>
                      </p>
                      <TextField
                        fullWidth
                        size="small"
                        type={"number"}
                        {...minSequenceRegister}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                          if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                          e.target.value = value;
                          minSequenceRegister.onChange(e);
                        }}
                      />
                    </div>
                    {errors.minSequenceNumber && (
                      <div className="error-container">
                        {errors.minSequenceNumber.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}></Grid2>

                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Max Sequence Number
                        <span>*</span>
                      </p>
                      <TextField
                        fullWidth
                        size="small"
                        type={"number"}
                        {...maxSequenceRegister}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                          if (value !== "0") value = value.replace(/^0+/, ""); // Remove leading zeros
                          e.target.value = value;
                          maxSequenceRegister.onChange(e);
                        }}
                      />
                    </div>
                    {errors.maxSequenceNumber && (
                      <div className="error-container">
                        {errors.maxSequenceNumber.message}
                      </div>
                    )}
                  </Grid2>
                </Grid2>

                <Grid2
                  alignItems={"end"}
                  justifyContent="end"
                  container
                  gap={3}
                  sx={{ marginTop: "2%" }}
                >
                  <Grid2 item md={6}>
                    <button
                      type="button"
                      className="create-btn-outlined"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "addUpdate-site-management",
                          navigate
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </Grid2>
                  <Grid2 item md={6}>
                    <button type="submit" className="create-btn">
                      Save
                    </button>
                  </Grid2>
                </Grid2>
              </Box>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default BulkKitStatus;
